<script lang="ts">
  import { ResponsiveVars, TwistGrid, TwistGridItem } from '@twist/core';
  import Container from '$components/News/Container.svelte';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import BlockBuLockup, { Align, ALL_BUs, Theme } from '$components/Logos/BlockBULockup.svelte';
  import { useEncodeDataAttribute, type ContentSourceMap } from '@sanity/svelte-loader';
  import PortableText from '$components/SanityComponents/PortableText/PortableText.svelte';
  import type { JobListingPage } from '$lib/sanity/schemas';
  import { sanityStudioURL } from '$lib/client';

  export let document: JobListingPage;
  export let sourceMap: ContentSourceMap | undefined = undefined;

  $: encodeDataAttribute = useEncodeDataAttribute(document, sourceMap, sanityStudioURL);

  const responsiveVars = new ResponsiveVars()
    .addFluid('section-py', toFluidVarInput(40, 80))
    .addFluid('h2-font-size', toFluidVarInput(20, 36))
    .addFluid('p-font-size', toFluidVarInput(18, 18))
    .addFluid('h2-mb', toFluidVarInput(12, 32))
    .addFluid('img-mb', [
      ['min', 32],
      ['sm', 'lg', 32, 64]
    ])
    .toCSS();
</script>

<section class={responsiveVars}>
  <Container>
    <TwistGrid rowGaps={toFluidVarInput(32, 0)}>
      <TwistGridItem colSpan={{ min: 4, lg: 5 }} display={{ min: 'none', lg: 'block' }}>
        <BlockBuLockup
          businessUnit={ALL_BUs}
          theme={Theme.DARK_ON_LIGHT}
          alignment={Align.CENTER}
        />
      </TwistGridItem>

      <TwistGridItem
        colSpan={{ min: 4, lg: 7 }}
        colStart={{ min: 1, lg: 6 }}
        rowStart={{ min: 1, lg: 1 }}
      >
        {#if document.content.pageContent}
          <div data-sanity={encodeDataAttribute(['pageContent'])}>
            <PortableText body={document.content.pageContent} />
          </div>
        {/if}
      </TwistGridItem>
    </TwistGrid>
  </Container>
</section>

<style lang="scss">
  @import 'src/scss/media';

  section {
    padding: var(--section-py) 0;
  }
  img {
    margin-bottom: var(--img-mb);

    @include at('lg') {
      margin-bottom: 0;
    }
  }
</style>
